<app-dynamic-form #form="dynamicForm" [config]="formFields" (submit)="submit($event)"> </app-dynamic-form>
